export const tourTypes = {
    TOUR_OPEN: '  TOUR_OPEN',
    TOUR_CLOSED: 'TOUR_CLOSED',
    UPDATE_TOUR_STEP: 'UPDATE_TOUR_STEP',
}
